
export class GoogleCalendarService {
    constructor() {
        this.clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
        this.redirectUri = process.env.REACT_APP_GOOGLE_REDIRECT_URI;
    }

    getAuthUrl(redirectUriOverride = "") {
        const scope = 'https://www.googleapis.com/auth/calendar.readonly';
        const redirectUri = redirectUriOverride || this.redirectUri;
        return `https://accounts.google.com/o/oauth2/v2/auth?` +
            `client_id=${this.clientId}` +
            `&redirect_uri=${encodeURIComponent(redirectUri)}` +
            `&response_type=code` +
            `&scope=${encodeURIComponent(scope)}` +
            `&access_type=offline` +
            `&include_granted_scopes=true` +
            `&prompt=consent`;
    }

    async getEvents(accessToken, timeMin, timeMax) {
        try {
            const response = await fetch(
                `https://www.googleapis.com/calendar/v3/calendars/primary/events?` +
                `timeMin=${timeMin.toISOString()}` +
                `&timeMax=${timeMax.toISOString()}` +
                `&singleEvents=true` +
                `&orderBy=startTime`,
                {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (!response.ok) {
                throw new Error('Failed to connect to calendar services');
            }

            const data = await response.json();
            return data.items;
        } catch (error) {
            console.error('Error fetching Google Calendar events:', error);
            throw error;
        }
    }
} 
